// Select all elements with the class "product-variant__container"
const selectElements = document.querySelectorAll(".product-variant__container");

// Add an event listener to each container
selectElements.forEach((selectElement) => {
  selectElement.addEventListener("click", (event) => {
    // Check if the clicked element is a radio input
    if (event.target.matches('input[type="radio"]')) {
      // Get the current custom element
      const customElement = document.getElementsByClassName("axt-cp-custom")[0];

      if (!customElement) {
        console.error("Custom element with class 'axt-cp-custom' not found.");
        return;
      }

      // Get old variant and product details
      const oldVariant = customElement.id;
      const oldProduct = customElement.getAttribute("axt-cp-product-id");

      // Wait for a short delay before applying changes
      setTimeout(() => {
        // Remove old classes
        customElement.classList.remove(oldVariant);
        customElement.classList.remove(oldProduct);

        // Get new variant and product IDs
        const variantId = document.querySelector('[name="id"]')?.value;
        const productId = document.querySelector('[name="product-id"]')?.value;

        if (!variantId || !productId) {
          console.error("Variant ID or Product ID not found in the DOM.");
          return;
        }

        // Add new classes and update attributes
        customElement.classList.add(variantId);
        customElement.classList.add(productId);

        customElement.id = productId;
        customElement.setAttribute("axt-cp-product-id", variantId);
      }, 100);
    }
  });
});

